// i18n.js
import Vue from "vue";
import VueI18n from "vue-i18n";
// 国际化 json 文件，文件内容详见下面的示例
import en from "./en.json";
import zhHans from "./zh-Hans.json";
import zhHant from "./zh-Hant.json";
const messages = {
  en,
  "zh-Hans": zhHans,
  "zh-Hant": zhHant,
};

let i18nConfig = {
  locale: localStorage.getItem("language") || "zh-Hans", // 获取已设置的语言
  messages,
};
Vue.use(VueI18n);

const i18n = new VueI18n(i18nConfig);
export function getLanguage() {
  let lang = "";

  if (typeof window !== "undefined") {
    const langs = navigator.languages || [navigator.language];
    lang = langs[0];
  }

  // 统一格式（全部转小写）
  lang = lang.toLowerCase().replaceAll("_", "-");

  // === 判断简繁体 ===
  if (["zh-tw", "zh-hk", "zh-hant"].includes(lang)) {
    return "zh-Hant"; // 繁体
  }

  if (["zh-cn", "zh-hans"].includes(lang)) {
    return "zh-Hans"; // 简体
  }

  return "en"; // 其他语言（英文等）
}

export default i18n;
